import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Acceptance of These Terms",
    body: [
      "By downloading, accessing, or using My Fresh Tracker (“the app”), you agree to be bound by these Terms & Conditions. If you do not agree with any part of them, please do not use the app.",
      "We may update these terms from time to time. The current version is always available on this page, and your continued use of the app after an update means you accept the revised terms.",
    ],
  },
  {
    heading: "What the App Does",
    body: [
      "My Fresh Tracker helps you record the groceries you buy, keep track of their expiry dates, scan printed dates with your camera, and receive reminders before items expire. It is a record-keeping and reminder aid — nothing more.",
    ],
  },
  {
    heading: "Disclaimer of Liability",
    highlight: true,
    body: [
      "My Fresh Tracker is a tool for convenience only. It does not — and cannot — determine whether any food item is actually fresh, safe, or fit to eat.",
      "You are solely responsible for checking the actual freshness and safety of your food. Always inspect items yourself before eating them, rely on the date printed on the packaging, and use your own judgment. When in doubt, throw it out — regardless of what the app displays.",
      "Expiry dates can be scanned, read, or entered incorrectly, and reminders may be delayed, missed, or fail to arrive. To the fullest extent permitted by law, My Fresh Tracker is not liable for any illness, injury, or loss resulting from incorrect expiry dates, missed notifications, or any other information provided by the app.",
      "Nothing in the app constitutes food-safety, health, nutritional, or medical advice. If you suspect that any food may be unsafe, do not consume it.",
    ],
  },
  {
    heading: "Your Responsibilities",
    body: [
      "You are responsible for the accuracy of the items and dates you enter, for keeping your device’s notification permissions enabled if you wish to receive reminders, and for how you use the information shown in the app.",
      "You agree not to misuse the app, attempt to disrupt it, or use it for anything unlawful.",
    ],
  },
  {
    heading: "Intellectual Property",
    body: [
      "The My Fresh Tracker name, logo, design, and all content provided in the app and on this website belong to us. You may not copy, reproduce, or reuse them without our written permission.",
    ],
  },
  {
    heading: "Changes to the Service",
    body: [
      "We may add, change, or remove features of the app at any time. We may also suspend or discontinue the service, in which case we will do our best to give you reasonable notice.",
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "If you have any questions about these Terms & Conditions, write to us at myfreshtracker@gmail.com.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      title="Terms & Conditions"
      subtitle="The plain-English rules for using My Fresh Tracker. Please read the Disclaimer of Liability carefully — it explains what the app can and cannot do."
      updated="August 2026"
      sections={SECTIONS}
    />
  );
}
